import React from 'react';
import { Link } from 'react-router-dom';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { 
    Info, 
    HelpCircle, 
    FileText, 
    Shield, 
    Mail,
    ExternalLink 
} from 'lucide-react';

const USEFUL_LINKS = [
    { to: '/despre-noi', label: 'Despre noi', icon: Info },
    { to: '/cum-functioneaza', label: 'Cum funcționează', icon: HelpCircle },
    { to: '/termeni', label: 'Termeni și condiții', icon: FileText },
    { to: '/confidentialitate', label: 'Politica de confidențialitate', icon: Shield },
    { to: '/ajutor', label: 'Ajutor', icon: HelpCircle },
    { to: '/cookie-policy', label: 'Politica de Cookies', icon: FileText },
    { to: '/contact', label: 'Contact', icon: Mail },
];

export const UsefulLinksModal = ({ open, onOpenChange }) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md" data-testid="useful-links-modal">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <ExternalLink className="w-5 h-5 text-primary" />
                        Linkuri utile
                    </DialogTitle>
                </DialogHeader>
                <div className="space-y-1 py-2">
                    {USEFUL_LINKS.map((link) => {
                        const Icon = link.icon;
                        return (
                            <Link
                                key={link.to}
                                to={link.to}
                                onClick={() => onOpenChange(false)}
                                className="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-gray-50 transition-colors"
                                data-testid={`useful-link-${link.to.replace('/', '')}`}
                            >
                                <Icon className="w-5 h-5 text-primary" />
                                <span className="font-medium">{link.label}</span>
                            </Link>
                        );
                    })}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default UsefulLinksModal;
